import storage from 'src/services/storage'
import { TOKEN } from 'src/helpers/constant'
import router from 'src/router'
import { Auth } from 'aws-amplify'
import { setAmplifySessionFromTokens } from 'src/helpers/amplifyAuth'
import {
  clearMenuPermissionCache,
  loadCurrentMenuPermissions
} from 'src/services/menu'

const state = {
  userInfo: null
}

const getters = {}

const mutations = {
  updateUser(state, item) {
    state.userInfo = item
  }
}

const actions = {
  async login(context, tokenData) {
    clearMenuPermissionCache()
    context.dispatch('menu/resetMenu', null, { root: true })

    // Support both string (AccessToken) and object (full token response)
    if (typeof tokenData === 'string') {
      // Backward compatibility: just store token
      storage.set(TOKEN, tokenData)
    } else if (tokenData && tokenData.AccessToken) {
      // New format: store AccessToken and set Amplify session
      storage.set(TOKEN, tokenData.AccessToken)
      
      // Set session in AWS Amplify for compatibility with password change, etc.
      try {
        await setAmplifySessionFromTokens({
          AccessToken: tokenData.AccessToken,
          IdToken: tokenData.IdToken,
          RefreshToken: tokenData.RefreshToken
        })
        // Session set successfully - continue silently
      } catch (error) {
        // Could not set Amplify session, but token is stored for API calls
        // Continue anyway - this is not a critical error
      }
    } else {
      storage.set(TOKEN, tokenData)
    }

    try {
      const permissionData = await loadCurrentMenuPermissions(true)
      context.dispatch('menu/applyMenuPermissionFilter', permissionData, { root: true })
    } catch (error) {
      context.dispatch('menu/showDefaultMenu', null, { root: true })
    }
  },
  logout(context) {
    storage.remove(TOKEN)
    clearMenuPermissionCache()
    context.dispatch('menu/resetMenu', null, { root: true })
    if (router.currentRoute.name !== 'Login') {
      router.push({ name: 'Login' })
    }
    Auth.signOut()
    context.commit('updateUser', null)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
